@if (control() && control().invalid && control().dirty) {
  <p
    [id]="id()"
    class="field-error"
    data-cy="field_error"
    [style]="errorStyles()"
  >
    @for (item of control().errors | keyvalue; track $index) {
      {{ !!item.key ? errorMessagesValue()[item.key] : '' }}
    }
  </p>

  @if (serverErrorMessage()) {
    <p class="invalid-feedback">
      {{ serverErrorMessage() }}
    </p>
  }
}
